module.exports = __webpack_public_path__ + "img/bg@3x.c7ab6906.png";